function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M21 12v10h-6v-6H9v6H3V12H0L12 0l12 12h-3zm-1-5.907V1h-3v2.093l3 3z",
  fill: "#000"
});

function SvgHomeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCAyNCAyMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIxIDEyVjIySDE1VjE2SDlWMjJIM1YxMkgwTDEyIDBMMjQgMTJIMjFaTTIwIDYuMDkzVjFIMTdWMy4wOTNMMjAgNi4wOTNaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K";
export { SvgHomeIcon as ReactComponent };